/**
 * Copyright © 2025-2026 Delicious AI, LLC
 */

import * as Sentry from '@sentry/react'

Sentry.init({
  dsn: import.meta.env.VITE_APP__SENTRY_DSN,
  environment: import.meta.env.VITE_APP__ENVIRONMENT,
  sendDefaultPii: false,
  integrations: [
    Sentry.replayIntegration({
      blockAllMedia: false,
      maskAllText: false,
      maskAllInputs: false,
    }),
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
})
